import { Control } from 'react-hook-form'
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import useQueryGetDepositPromotionNamesForSelector from '@/modules/promotion/api/hooks/useQueryGetDepositPromotionNamesForSelector'
import useQueryGetBatchesForBrokeNotification from '@/modules/batches/api/hooks/useQueryGetBatchesForBrokeNotification'
import { CreateBrokeFlexMessageItemDtoType } from '@/modules/messaging/types'
import type { NotificationItemFormData } from '../types'

interface ConditionalFieldsProps {
	control: Control<NotificationItemFormData>
	selectedType?: CreateBrokeFlexMessageItemDtoType
}

export default function ConditionalFields({
	control,
	selectedType,
}: ConditionalFieldsProps) {
	const { data: depositPromotions } =
		useQueryGetDepositPromotionNamesForSelector()
	const { data: couponBatches } = useQueryGetBatchesForBrokeNotification()

	if (selectedType === CreateBrokeFlexMessageItemDtoType.DEPOSIT_PROMOTION) {
		return (
			<FormField
				control={control}
				name="promotionId"
				render={({ field }) => (
					<FormItem>
						<FormLabel required>โปรโมชั่นฝาก</FormLabel>
						<Select value={field.value} onValueChange={field.onChange}>
							<FormControl>
								<SelectTrigger>
									<SelectValue placeholder="เลือกโปรโมชั่น" />
								</SelectTrigger>
							</FormControl>
							<SelectContent>
								{depositPromotions?.data.map((promo) => (
									<SelectItem key={promo.id} value={promo.id}>
										{promo.name}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
						<FormDescription>เลือกโปรโมชั่นฝากที่ต้องการแนะนำ</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		)
	}

	if (selectedType === CreateBrokeFlexMessageItemDtoType.COUPON) {
		return (
			<FormField
				control={control}
				name="couponCode"
				render={({ field }) => (
					<FormItem>
						<FormLabel required>คูปอง</FormLabel>
						<Select value={field.value} onValueChange={field.onChange}>
							<FormControl>
								<SelectTrigger>
									<SelectValue placeholder="เลือกคูปอง" />
								</SelectTrigger>
							</FormControl>
							<SelectContent>
								{couponBatches?.data.map((batch) => (
									<SelectItem key={batch.id} value={batch.id}>
										{batch.name}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
						<FormDescription>
							เลือกชุดคูปองแบบใช้ครั้งเดียวที่ต้องการแนะนำ
						</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		)
	}

	if (selectedType === CreateBrokeFlexMessageItemDtoType.CUSTOM_LINK) {
		return (
			<FormField
				control={control}
				name="actionUrl"
				render={({ field }) => (
					<FormItem>
						<FormLabel required>URL ปลายทาง</FormLabel>
						<FormControl>
							<Input {...field} placeholder="https://example.com/action" />
						</FormControl>
						<FormDescription>URL ที่จะเปิดเมื่อคลิกรายการ</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		)
	}

	return null
}
